import React from 'react';
import SkeletonGallery from './gallery';
import SkeletonMobile from './mobile';
import SkeletonRow from './row';
import SkeletonTeaser from './teaser';
export default (props) => {
    if (props.type == 'gallery')
        return (React.createElement(SkeletonGallery, null));
    else if (props.type == 'mobile')
        return (React.createElement(SkeletonMobile, null));
    else if (props.type == 'row')
        return (React.createElement(SkeletonRow, null));
    else if (props.type == 'teaser')
        return (React.createElement(SkeletonTeaser, null));
    else
        return (React.createElement(SkeletonGallery, null));
};
